import { render, staticRenderFns } from "./DocumentFiltering.vue?vue&type=template&id=41922496&scoped=true&"
import script from "./DocumentFiltering.vue?vue&type=script&lang=js&"
export * from "./DocumentFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41922496",
  null
  
)

export default component.exports